<template>
  <div class="vote-record">
    <div class="vr-header">
      <van-icon name="arrow-left" class="vr-back" @click="back()" />
      <span class="vr-title">Voting record</span>
      <van-icon name="apps-o" class="vr-grid" />
    </div>

    <div class="vr-tabs">
      <div
        class="vr-tab"
        :class="{ active: activeTab === tab.key }"
        v-for="tab in tabs"
        :key="tab.key"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </div>
    </div>

    <div class="vr-body">
      <van-loading v-if="loading" class="vr-loading" color="#f0607f" />

      <div v-else-if="!filteredList.length" class="vr-empty">
        <van-empty image-size="120" description="No Data Available" />
      </div>

      <div v-else class="vr-list">
        <div class="vr-card" v-for="(v, key) in filteredList" :key="key">
          <div class="vr-card-top">
            <span class="vr-period">{{ v.expect }}</span>
            <span class="vr-status" :class="statusClass(v)">{{ statusLabel(v) }}</span>
          </div>
          <div class="vr-card-mid">
            <span class="vr-name">{{ activityName(v.name) }}</span>
            <div class="vr-result">
              <span class="vr-pill">{{ sizeLabel(v) }}</span>
              <span class="vr-pill">{{ doubleLabel(v) }}</span>
            </div>
          </div>
          <div class="vr-card-foot">
            <span>Dot: {{ v.money }}</span>
            <span>{{ v.create_time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      list: [],
      activeTab: "all",
      tabs: [
        { key: "all", label: "All" },
        { key: "win", label: "Points Earned" },
        { key: "pending", label: "To Be Drawn" },
      ],
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === "win") {
        return this.list.filter((v) => Number(v.is_win) === 1);
      }
      if (this.activeTab === "pending") {
        return this.list.filter((v) => Number(v.status) === 0);
      }
      if (this.activeTab === "lose") {
        return this.list.filter((v) => Number(v.is_win) === 2);
      }
      return this.list;
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    parseCodes(v) {
      const codes = v && v.opencode;
      if (Array.isArray(codes) && codes.length >= 3) {
        return [Number(codes[0]), Number(codes[1]), Number(codes[2])];
      }
      return null;
    },
    sizeLabel(v) {
      const codes = this.parseCodes(v);
      if (!codes) return "--";
      const total = codes[0] + codes[1] + codes[2];
      if (total >= 11 && total <= 18) return "Rose";
      if (total >= 3 && total <= 10) return "Ship";
      return "--";
    },
    doubleLabel(v) {
      const codes = this.parseCodes(v);
      if (!codes) return "--";
      const total = codes[0] + codes[1] + codes[2];
      return total % 2 === 0 ? "Rocket" : "Heart";
    },
    statusLabel(v) {
      if (Number(v.is_win) === 1) return "Win";
      if (Number(v.is_win) === 2) return "Lose";
      return "Pending";
    },
    statusClass(v) {
      if (Number(v.is_win) === 1) return "win";
      if (Number(v.is_win) === 2) return "lose";
      return "pending";
    },
    activityName(name) {
      const n = String(name || "").trim();
      if (n === "空降活动" || n === "投票活动") {
        return "Voting Activity";
      }
      return name;
    },
    getUserGameList() {
      this.loading = true;
      this.$http({
        method: "get",
        url: "user_get_game_list",
      })
        .then((res) => {
          if (res && res.code === 200) {
            this.list = Array.isArray(res.data) ? res.data : [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang="less" scoped>
*,
:after,
:before {
  box-sizing: border-box;
}

.vote-record {
  min-height: 100vh;
  background: #fff;
}

.vr-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 92px;
  border-bottom: 1px solid #f0f0f0;
}
.vr-back {
  position: absolute;
  left: 24px;
  font-size: 40px;
  color: #999;
}
.vr-title {
  font-size: 34px;
  font-weight: 700;
  color: #2b2b2b;
}
.vr-grid {
  position: absolute;
  right: 24px;
  font-size: 36px;
  color: #bbb;
}

.vr-tabs {
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-bottom: 1px solid #f3f3f3;
}
.vr-tab {
  flex: 1;
  text-align: center;
  padding: 26px 6px;
  font-size: 26px;
  color: #f29bb4;
  position: relative;
  white-space: nowrap;
}
.vr-tab.active {
  color: #f0607f;
  font-weight: 700;
}
.vr-tab.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
  width: 44px;
  height: 6px;
  border-radius: 6px;
  background: #f0607f;
}

.vr-body {
  padding: 20px;
}
.vr-loading {
  display: block;
  text-align: center;
  margin-top: 120px;
}
.vr-empty {
  margin-top: 80px;
}

.vr-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.vr-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}
.vr-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.vr-period {
  font-size: 26px;
  font-weight: 700;
  color: #333;
}
.vr-status {
  font-size: 24px;
  font-weight: 600;
}
.vr-status.win {
  color: #07c160;
}
.vr-status.lose {
  color: #ee0a24;
}
.vr-status.pending {
  color: #ff976a;
}
.vr-card-mid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.vr-name {
  font-size: 26px;
  color: #666;
}
.vr-result {
  display: flex;
  gap: 12px;
}
.vr-pill {
  padding: 6px 18px;
  border-radius: 80px;
  background: #f29bb4;
  color: #fff;
  font-size: 22px;
}
.vr-card-foot {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #999;
}
</style>
